import React, { Component } from 'react';
import {Link, browserHistory } from 'react-router';
import $ from 'jquery';
import { Modal,Button } from 'react-bootstrap';
import Icon, { FontAwesome, Feather } from 'react-web-vector-icons';

export default class WishList extends Component{
	constructor(props){
		super(props);
		this.state={
			cartcount:'',
			page_loading:false,
			wish_deals:[],
			cart_status:false,
			cart_status_msg:'',
			cart_added_status:false,
			clearcart_status:false,

			replace_deal_id:'',
			replace_deal_type:'',
			replace_qty:'',
			replace_pl_size:'',
			replace_salinity:'',
			replace_pickup_date:'',
			replace_id:'',
			replace_pro_title:'',
			emptyCartConfirm:false,
			cart_flag:'',
			
		}
		this.getDeals=this.getDeals.bind(this);
		this.addToCart=this.addToCart.bind(this);
		this.close=this.close.bind(this);
		this.replaceCartItems=this.replaceCartItems.bind(this);
		this.emptyCartConfirm=this.emptyCartConfirm.bind(this);
		this.emptyWishList=this.emptyWishList.bind(this);
		this.deleteSingleItem=this.deleteSingleItem.bind(this);
		this.tokenCheck=this.tokenCheck.bind(this);
	}
	componentDidMount()
	{
		if(!localStorage.token && !localStorage.user_id)
		{
			localStorage.setItem('wishlist','/wishlist');
			browserHistory.push('/login');
		}
		else
		{
			this.getDeals();
		}
	}
	deleteSingleItem(id)
	{
		this.setState({
			page_loading:true,
		});
		if(localStorage.source)
	    {
	       var source=localStorage.getItem('source');
	    }
	    else
	    {
	       source='';
	    }
	    if(localStorage.campaign)
	    {
	       var campaign=localStorage.getItem('campaign');
	    }
	    else
	    {
	       campaign='';
	    }
	    if(localStorage.url_id)
	    {
	       var url_id=localStorage.getItem('url_id');
	    }
	    else
	    {
	       url_id='';
	    }
		var baseUrl='https://aquadeals.in/admin/web3/user/';
		var data1={from:'mobile_web',id:id,token:localStorage.token,uid:localStorage.user_id,source:source,campain:campaign,url_id:url_id};
		var data2=JSON.stringify(data1);
		$.ajax({
			method:'POST',
			dataType:'json',
			data:{req:data2},
			url:baseUrl+'rmvFrmWshlst',
			success:function(data)
			{
				if(data.status==='success')
				{
					this.setState({
						page_loading:false,
					});
					this.getDeals();
				}
				if(data.status==='error' && data.message==='Token mismatch')
				{
					this.tokenCheck();
				}
				// else
				// {
				// 	this.setState({
				// 		page_loading:false,
				// 	});
				// }
			}.bind(this),
			error:function(err)
			{

			}
		});
	}
	tokenCheck()
	{
		localStorage.removeItem('user_id');
		localStorage.removeItem('token');
		window.location.reload();
	}
	getDeals()
	{
		this.setState({
			page_loading:true,
		});
		if(localStorage.source)
      {
        var source=localStorage.getItem('source');
      }
      else
      {
        source='';
      }
      if(localStorage.campaign)
      {
        var campaign=localStorage.getItem('campaign');
      }
      else
      {
        campaign='';
      }
      if(localStorage.url_id)
      {
        var url_id=localStorage.getItem('url_id');
      }
      else
      {
        url_id='';
      }
		var baseUrl='https://aquadeals.in/admin/web3/user/';
		var data1={from:'mobile_web',id:localStorage.user_id,token:localStorage.token,source:source,campaign:campaign,url_id:url_id};
		var data2=JSON.stringify(data1);
		$.ajax({
			method:'POST',
			dataType:'json',
			url:baseUrl+'Wishlist',
			data:{req:data2},
			success:function(data)
			{
				if(data.status==='success')
				{
					this.setState({
						page_loading:false,
						wish_deals:data.lst_items,
						cartcount:data.count,
					});
				}
				else if(data.status==='error' && data.message==="Token mismatch")
				{
					this.tokenCheck();
				}
				else
				{
					this.setState({
						page_loading:false,
					});
				}
			}.bind(this),
			error:function(err)
			{
				this.setState({
					page_loading:false,
				});
			}
		});
	}
	addToCart(deal_id,deal_type,qty,pl_size,salinity,pickup_date,id,pro_title)
	{
		if(localStorage.source)
      {
        var source=localStorage.getItem('source');
      }
      else
      {
        source='';
      }
      if(localStorage.campaign)
      {
        var campaign=localStorage.getItem('campaign');
      }
      else
      {
        campaign='';
      }
      if(localStorage.url_id)
      {
        var url_id=localStorage.getItem('url_id');
      }
      else
      {
        url_id='';
      }
		this.setState({
			replace_deal_id:deal_id,
			replace_deal_type:deal_type,
			replace_qty:qty,
			replace_pl_size:pl_size,
			replace_salinity:salinity,
			replace_pickup_date:pickup_date,
			replace_id:id,
			replace_pro_title:pro_title,source:source,campaign:campaign,url_id:url_id
		});
		var baseUrl='https://aquadeals.in/admin/web3/user/';
		var data1={from:'mobile_web',id:localStorage.user_id,token:localStorage.token,deal_id:deal_id,deal_type:deal_type,quantity:qty,pl_size:pl_size,salinity:salinity,pickup_date:pickup_date,wishLst_id:id,wishLst_flag:'1'}
		var data2=JSON.stringify(data1);
		$.ajax({
			method:'POST',
			dataType:'json',
			url:baseUrl+'addToCart',
			data:{req:data2},
			success:function(data)
			{
				if(data.status==="success" && data.message==="Added to cart")
				{
					this.setState({
						cart_status:true,
						cart_status_msg:data.message,
					});
					this.getDeals();
				}
				if(data.status==="success" && data.message==="Cart Updated")
				{
					this.setState({
						cart_status:true,
						cart_status_msg:data.message,
					});
				}
				if(data.status==="error"  && data.cart_flag===0)
				{
					this.setState({
						clearcart_status:true,
					});
				}
				if(data.status==="error" && data.message==="Product already added to the cart" && data.cart_flag ===1)
				{
					this.setState({
						cart_added_status:true,
					});
				}
				this.getDeals();
			}.bind(this),
			error:function(err)
			{

			}
		});
	}
	close()
	{
		this.setState({
			cart_status:false,
			clearcart_status:false,
			cart_added_status:false,
			emptyCartConfirm:false,
		})
	}
	replaceCartItems()
  	{
  		if(localStorage.source)
      {
        var source=localStorage.getItem('source');
      }
      else
      {
        source='';
      }
      if(localStorage.campaign)
      {
        var campaign=localStorage.getItem('campaign');
      }
      else
      {
        campaign='';
      }
      if(localStorage.url_id)
      {
        var url_id=localStorage.getItem('url_id');
      }
      else
      {
        url_id='';
      }
  		var baseUrl='https://aquadeals.in/admin/web3/user/';
		var data1={from: 'mobile_web',id:localStorage.getItem('user_id'),token:localStorage.getItem('token'),deal_id:this.state.replace_deal_id,deal_type:this.state.replace_deal_type,quantity:this.state.replace_qty,pl_size:this.state.replace_pl_size,salinity:this.state.replace_salinity,pickup_date:this.state.replace_pickup_date,source:source,campaign:campaign,url_id:url_id,wishLst_flag:'1',wishLst_id:this.state.replace_id}
	    var data2=JSON.stringify(data1);
	    $.ajax({
			method:'post',
			dataType:'json',
			url: baseUrl+'replaceCart',
			data:{req:data2},
			success:function(data)
			{
				if(data.status==="success" && data.cart_flag===1)
				{
					this.setState({
						clearcart_status:false,
						cart_status:true,
						cart_status_msg:data.message,
					});
				}
				this.getDeals();
			}.bind(this),
			error:function(err)
			{
				// console.log(err)
			}
		});
  	}
  	emptyCartConfirm()
	{
		
		this.setState({
			emptyCartConfirm:true,
		});
	}
	emptyWishList()
	{
		if(localStorage.source)
      {
        var source=localStorage.getItem('source');
      }
      else
      {
        source='';
      }
      if(localStorage.campaign)
      {
        var campaign=localStorage.getItem('campaign');
      }
      else
      {
        campaign='';
      }
      if(localStorage.url_id)
      {
        var url_id=localStorage.getItem('url_id');
      }
      else
      {
        url_id='';
      }
		this.setState({
			emptyCartConfirm:false,
		});
		var baseUrl='https://aquadeals.in/admin/web3/user/';
		var data1={from:'mobile_web',id:localStorage.user_id,token:localStorage.token,source:source,campaign:campaign,url_id:url_id};
		var data2=JSON.stringify(data1);
		$.ajax({
			method:'POST',
			dataType:'json',
			data:{req:data2},
			url:baseUrl+'clearWishlist',
			success:function(data)
			{
				if(data.status==='success')
				{
				}
				this.getDeals();
			}.bind(this),
			error:function(err)
			{
				
			}
		});
	}
	render(){
		document.title="WishList | AquaDeals";
		var wishdeals_list=this.state.wish_deals.map(function(data,index){
			return(
				<div className="col-md-6 col-sm-6 col-xs-5 mob_wish_deal_blks" >
					{/*<Link style={{textDecoration:'none',color:'#333'}} to={'/'} >*/}
					<span onClick={()=>{this.deleteSingleItem(data.id)}}>
					<Icon
	                    name='close'
	                    font='SimpleLineIcons'
	                    color='#bbb'
	                    size={16}
	                    style={{position:'absolute',right:'10px',top:'8px',cursor:'pointer'}}
	                 />
	                 </span>					
					<Link style={{textDecoration:'none',color:'#333'}} to={data.type === 0 ? "/sdetails/"+data.sname+"/"+data.deal_id : "/pdetails/"+data.url_dtype_name+"/"+data.url_cat_name+"/"+data.url_brand_name+"/"+data.url_product_name+"/"+data.pid+"/"+data.deal_id}  >
						<div style={{paddingLeft:'10px',paddingRight:'10px'}}>
						 	{data.type ===0 ? <img src={data.img !== null && data.img !=='' ? data.img : 'https://aquadeals.in/admin/assets/icons/web_icons/noImage.png'} alt="" /> : <img src={data.img !==null && data.img !=='' ? data.img : 'https://aquadeals.in/admin/assets/icons/web_icons/noImage.png'} alt="" /> }
						</div>
						{data.pro_name ? <h5 className="mob_wish_title">{data.pro_name}</h5>: <h5 className="mob_wish_title">&nbsp;</h5>}
						{data.brand !==null && data.brand !=="" ? <h6 className="mob_wish_brand">{data.brand}</h6> :  <h6 className="mob_wish_brand">&nbsp;</h6>}
						{data.mrp ? <h6 className="mob_wish_mrp">MRP : ₹ {data.mrp} </h6> : <h6 className="mob_wish_mrp">&nbsp;</h6>}
						{/*{data.deal_price ? <h6 className="mob_pro_ofr">Promotional Offer :  ₹ {data.deal_price} </h6> : <h6 className="mob_pro_ofr">&nbsp;</h6>}*/}
					</Link>
					{data.cart_flag ===1 ? <div className="mob_wish_add_blk"><a className="mob_wish_add_cart_btn" href="/mycart">GO TO CART</a></div> : <div className="mob_wish_add_blk"><a className="mob_wish_add_cart_btn" onClick={()=>{this.addToCart(data.deal_id,data.type,data.qty,data.pl_size,data.salinity,data.pickup_date,data.id,data.pro_name)}}>ADD TO CART</a></div>}
				</div>
			)
		}.bind(this))
		return(
			<div className="mob_deals mob_wishlist">
				<div className="page_hdr">
				   {/* {this.state.cartcount !==0 ?  */}
				      	<div className="container-fluid">
				      		<h5><Link onClick={()=>{browserHistory.goBack()}}><i><img src={'https://aquadeals.in/admin/assets/icons/web_icons/close_icon1.png'} className="cross_icon" width="14px" alt=""/></i></Link><span className="header_text">WishList</span></h5>
					        <a href="/" className="home_newicon"><img src={'https://aquadeals.in/admin/assets/icons/web_icons/home1.png'} alt="Home" /></a>
					        {/*<a className="cart_emptybtn" onClick={()=>{this.emptyCartConfirm()}}><img alt="" src={'https://aquadeals.in/admin/assets/icons/web_icons/del_bin3.png'} /></a>*/}
					        <a className="cart_emptybtn" onClick={()=>{this.emptyCartConfirm()}}><img alt="" src={'https://aquadeals.in/admin/assets/icons/web_icons/del_bin3.png'} /></a>
					    </div>
				{/*	:  
					    <div className="container-fluid">
					        <h5><Link to={'/'}><i><img src={'https://aquadeals.in/admin/assets/icons/web_icons/close_icon1.png'} width="16px" alt=""/></i></Link> WishList</h5>
					        <a href="/" className="home_newicon"><img src={'https://aquadeals.in/admin/assets/icons/web_icons/home1.png'} alt="Home" /></a>
					    </div>
					} */}
				</div>
				<div className="clr">&nbsp;</div>
			    <div className="clr">&nbsp;</div>
			    <div className="clr">&nbsp;</div>
			    {this.state.cartcount !==0 ?
			    	<div style={{marginBottom:'30px'}}>
			    		{this.state.page_loading ? <div className="checkout_loading"><img src={'https://aquadeals.in/admin/assets/images/loading_more.gif'} alt="Loading"  /></div>:
			    			<div>
			    				<section className="container-fluid">
			    					<div className="row" style={{backgroundColor:'#f2f2f2',paddingTop:'10px',paddingBottom:'10px'}}>
								 		<div className="col-md-6 col-sm-6 col-xs-6">{this.state.cartcount >1  ? 'Items : '+this.state.cartcount : 'Item : '+this.state.cartcount} </div>
								 	</div>
			    				</section>
			    				<section className="container-fluid">
				    				<div className="row">
				    					{wishdeals_list}
				    				</div>
			    				</section>
			    				{this.state.page_loading ? <i className="pro_load_img"><img src={'https://aquadeals.in/admin/assets/images/loading_more.gif'} alt="Loading" /></i> : ''}
			    				<Modal className="wish_modals"  show={this.state.cart_status} onHide={this.close}  >
									<Modal.Header closeButton>
							    		<Modal.Title className="wish_modal_title">Alert</Modal.Title>
							  		</Modal.Header>
							  		<Modal.Body>
							  			<h4 className="wish_modal_h4">{this.state.cart_status_msg}</h4>
							  		</Modal.Body>
							  		<Modal.Footer className="modal_footer">
								  		<Button onClick={this.close}>Close</Button>
								  	</Modal.Footer>
							  	</Modal>
							  	<Modal className="wish_modals"  show={this.state.clearcart_status} onHide={this.close}  >
									<Modal.Header closeButton>
							    		<Modal.Title className="wish_modal_title">Alert</Modal.Title>
							  		</Modal.Header>
							  		<Modal.Body>
							  			<h4 className="wish_modal_h4">You can't have multiple seller items in the cart. Empty existing cart & add this item {this.state.replace_pro_title}?</h4>
							  		</Modal.Body>
							  		<Modal.Footer className="modal_footer">
						  				<Button onClick={this.close}>NO</Button>
						  				<a><Button onClick={()=>{this.replaceCartItems()}}>YES</Button></a>
							  		</Modal.Footer>
								</Modal>
								<Modal className="wish_modals"  show={this.state.cart_added_status} onHide={this.close}  >
									<Modal.Header closeButton>
							    		<Modal.Title className="wish_modal_title">Alert</Modal.Title>
							  		</Modal.Header>
							  		<Modal.Body>
							  			<h4 className="wish_modal_h4">Product already added to the cart!</h4>
							  		</Modal.Body>
							  		<Modal.Footer className="modal_footer">
								  		<Button onClick={this.close}>Close</Button>
								  	</Modal.Footer>
							  	</Modal>
							  	<Modal className="wish_modals" show={this.state.emptyCartConfirm} onHide={this.close}  >
									<Modal.Body>
							  			<h5>Do you want to remove all items? </h5>
							  		</Modal.Body>
							  		<Modal.Footer className="mob_cart_confirm">
							  			<Button className="" onClick={this.close}>NO</Button>
							  			<a><Button onClick={()=>{this.emptyWishList()}}>YES</Button></a>
							  		</Modal.Footer>
								</Modal>
			    			</div>
			    		}
				</div> : <div className="wishlist_emtpy">
								<i><img src={'https://aquadeals.in/admin/assets/icons/web_icons/empty_cartbg.png'} alt="..." /></i>
								<h4 style={{marginBottom:'25px',marginTop:'10px'}}>Your Wishlist is Empty</h4>
								<Link to={"/"} className="wish_shopbtn">SHOP NOW</Link>
							</div>}
				</div>
		);
	}
}


/** WEBPACK FOOTER **
 ** ./src/components/Categories/WishList/WishList.js
 **/